// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"premium-PlansOverviewUpgrade__wrapper--3USAk","btns":"premium-PlansOverviewUpgrade__btns--QPaVK"};